import AbstractValidator from './abstractValidator';

/**
 * @class ItemSuccessorValidator
 * @extends AbstractValidator
 */
export default class ItemSuccessorValidator extends AbstractValidator {
    /**
     * @param {ProblemFactory} problemFactory
     * @param {string} message
     */
    constructor(problemFactory, message) {
        super(problemFactory);
        this.message = message;
    }

    _isItemValid(item) {
        return !item.get('successorItemId');
    }

    _createProblems(item) {
        return [this.problemFactory.createSuccessorWarning('itemSuccessor', this.message, 'exchange', [item])];
    }
}
